import { useEffect, useState } from 'react';
import TabList from '../../Shared/TabList';
import TabListNavItem from '../../Shared/TabList/components/TabListNavItem';
import TabListTabContent from '../../Shared/TabList/components/TabListTabContent';
import OrganizationRegistrationForm from './components/OrganizationRegistrationForm';
import PrivateIndividualRegistrationForm from './components/PrivateIndividualRegistrationForm';
import { TranslationService } from '../../../services/translation.service';
import { Status } from '../../../hooks/fetch.hook';
import { SubmitSource, SubmitState } from './components/models/submit-state.model';
import SubmitSuccessful from '../../Shared/SubmitSuccessful';

function StralkastarenRegistration() {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const [submitSuccessState, setSubmitSuccessState] = useState<SubmitState>({
    isSubmitted: false,
    status: Status.notperformed,
    errorCode: undefined,
    source: SubmitSource.Private,
  });

  useEffect(() => {
    if (submitSuccessState.isSubmitted) {
      document.getElementById('form-submit-result')?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [submitSuccessState.isSubmitted]);

  return (
    <div className="stralkastaren-registration">
      {!submitSuccessState.isSubmitted && (
        <TabList
          id="stralkastaren-registration-tab-list"
          activeIndex={activeTabIndex}
          renderTabsAsDropdownOnMobile={true}
          dropdownLabel="Vilket registreringsformulär vill du se?"
          onSelectedChange={setActiveTabIndex}
          navItems={[<TabListNavItem key={'nav-item-0'}>Privatperson</TabListNavItem>, <TabListNavItem key={'nav-item-1'}>Företag</TabListNavItem>]}
          tabContents={[
            <TabListTabContent key={'tab-item-0'}>
              <PrivateIndividualRegistrationForm onSubmitSuccessful={setSubmitSuccessState} />
            </TabListTabContent>,
            <TabListTabContent key={'tab-item-1'}>
              <OrganizationRegistrationForm onSubmitSuccessful={setSubmitSuccessState} />
            </TabListTabContent>,
          ]}
        ></TabList>
      )}

      {submitSuccessState.isSubmitted && (
        <div className="form-submit-result" role="alert">
          {submitSuccessState.status === Status.success && (
            <SubmitSuccessful
              successText={TranslationService.get(
                submitSuccessState.source === SubmitSource.Private ? 'stralkastarenregistrationpage.privateindividualthankyoutext' : 'stralkastarenregistrationpage.organizationthankyoutext'
              )}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default StralkastarenRegistration;
